import fetchData from "../API/Fetch";
import { store } from "../store";

export default async function fetchResidences() {
  let result = await fetchData(`/residences/`);

  store.dispatch({
    type: "residences/update",
    payload: result ? result : [],
  });
  return result;
}
